import type { EdmDateTimeOffset, EdmGuid } from "./odata-types.ts";

const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isEdmGuid = (value: unknown): value is EdmGuid => {
    return typeof value === "string" && guidRegex.test(value);
};

const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;

export const isEdmDateTimeOffset = (value: unknown): value is EdmDateTimeOffset => {
    return typeof value === "string" && iso8601Regex.test(value);
};

const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;

export const isEdmDateOnly = (value: unknown): value is string => {
    return typeof value === "string" && isoDateRegex.test(value);
};

export const escapeSingleQuotes = (value: string) => {
    return value.replace(/'/g, "''");
};
